import React from 'react';
import createReactClass from 'create-react-class';

import { getOptionValue } from '@/exceed';
import omit from 'lodash/omit';
import { withContainer } from 'core/cache';

import { getIframeUrl } from '../helpers/getMockData';

import InsightsDashboard from '../components/insightsDashboard';

const InsightsDashboardContainer = createReactClass({
  getInitialState() {
    const {
      dashboardableId,
      dashboardableType,
      filters,
    } = this.props;

    return {
      data: filters.reduce((a, { defaultValue, key, options }) => ({
        ...a,
        ...{ [key]: getOptionValue(defaultValue, options) },
      }), { dashboardable_id: dashboardableId, dashboardable_type: dashboardableType }),
    };
  },

  componentDidMount() {
    this.fetchDashboard();
  },

  handleClearButtonClick() {
    this.setState({ data: this.getInitialState().data }, this.fetchDashboard);
  },

  handleFilterChange({
    isSelected,
    isSingleSelect,
    key,
    value,
  }) {
    this.setState(({ data }) => {
      if (isSingleSelect) {
        return { data: { ...data, [key]: isSelected ? value : null } };
      }

      const currentValues = data[key] || [];

      const newValues = isSelected
        ? [...currentValues, value]
        : currentValues.filter((currentValue) => currentValue !== value);

      return { data: { ...data, [key]: newValues } };
    }, this.fetchDashboard);
  },

  handleFooterClick() {
    const {
      dashboardableId,
      history,
      match: { params: { type } },
      nextDashboard,
    } = this.props;

    const url = type === 'initiatives'
      ? `/${type}/edit/${dashboardableId}/insights`
      : `/${type}/${dashboardableId}/insights`;

    history.push(`${url}/${nextDashboard.id}`);
  },

  fetchDashboard() {
    this.props.dashboard.mutate({ data: this.state.data });
  },

  render() {
    const {
      dashboard,
      description,
      filters,
      isEmpty,
      nextDashboard,
      title,
      timestamp,
    } = this.props;

    const filterSelection = omit(this.state.data, [
      'dashboardable_id',
      'dashboardable_type',
    ]);

    return (
      <InsightsDashboard
        description={description}
        filters={filters}
        filterSelection={filterSelection}
        isEmpty={isEmpty}
        isLoading={dashboard.status !== 'success'}
        nextDashboard={nextDashboard}
        onClearButtonClick={this.handleClearButtonClick}
        onFilterChange={this.handleFilterChange}
        onFooterClick={this.handleFooterClick}
        timestamp={timestamp}
        title={title}
        url={dashboard.data.url}
      />
    );
  },
});

export default withContainer(InsightsDashboardContainer, {
  cache: {
    dashboard: {
      getMockedResponse: () => ({ data: { url: getIframeUrl() } }),
      getParams: ({ props }) => ({ dashboardId: props.id }),
      initialData: {},
      isMocked: false,
      method: 'post',
      transform: ({ data }) => data.data,
      url: '/api/admin/dashboards/:dashboardId/generate_url',
    },
  },
  hasRouter: true,
});
